import { AxiosResponse } from 'axios';

import { isPartialAxiosError, isPartialAxiosErrorResponse } from 'apis/axiosUtils';

const getErrorResponseText = (response: AxiosResponse) => {
  const { data } = response;

  if (data && typeof data === 'string') {
    return data;
  }

  if (data && data.message && typeof data.message === 'string') {
    return data.message;
  }

  if (data && data.msg && typeof data.msg === 'string') {
    return data.msg;
  }

  return undefined;
};

const getErrorContent = (error: any): string | undefined => {
  if (!error) {
    return '<missing error data>';
  }

  if (isPartialAxiosError(error) && error.response) {
    return getErrorResponseText(error.response);
  }

  if (isPartialAxiosErrorResponse(error)) {
    return getErrorResponseText(error);
  }

  if (typeof error === 'string') {
    return undefined;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return JSON.stringify(error);
};

export default getErrorContent;
